import { getApiBaseUrl } from './apiConfig';
import { fetchWithTimeout } from './fetchWithTimeout';

/**
 * Fetch the most recent previous skin analysis for the same contact and same organization.
 * Organization is resolved from app_session_token on the backend (app_link).
 * Used for Before/After spider graph comparison.
 * @param {string} sessionId - Current session_id (skin_reference)
 * @param {string} [appSessionToken] - Session token from URL (for org scoping)
 * @returns {Promise<{ success: boolean, previous: null | { skin_id, created_at, detections, skinConditions, skinScore } }>}
 */
export async function getPreviousSkinAnalysis(sessionId, appSessionToken) {
  if (!sessionId || typeof sessionId !== 'string') {
    return { success: true, previous: null };
  }
  const base = getApiBaseUrl();
  if (!base) {
    return { success: true, previous: null };
  }
  const params = new URLSearchParams();
  params.set('session_id', sessionId);
  if (appSessionToken && String(appSessionToken).trim()) {
    params.set('app_session_token', String(appSessionToken).trim());
  }
  const url = `${base}/api/previous-skin-analysis?${params.toString()}`;
  const res = await fetchWithTimeout(url, { method: 'GET', headers: { Accept: 'application/json' }, timeoutMs: 20000 });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    return { success: false, previous: null };
  }
  // Debug: log previous payload for troubleshooting radar before-data
  try {
    if (data && data.previous) {
      console.debug('previousSkinAnalysis: previous payload', data.previous);
    } else {
      console.debug('previousSkinAnalysis: no previous payload', data);
    }
  } catch (e) {
    // ignore logging errors
  }
  return { success: Boolean(data.success), previous: data.previous || null };
}
